<div class="calendar__footer">
    <div class="timezone">
        <p>{{ currentTimezone }}</p>
    </div>

    <ul  class="ulCaptions">
        <li>
            <div class="subtitle-icon online"></div>
            {{ 'SCHEDULE.SESSIONTYPES.ONLINE' | translate }}
        </li>
        <li>
            <div class="subtitle-icon presential"></div>
            {{ 'SCHEDULE.SESSIONTYPES.PRESENTIAL' | translate }}
            <span class="freud-icon freud-icon-diamond sessPresential"></span>
        </li>
        <li>
            <div class="subtitle-icon private"></div>
            {{ 'SCHEDULE.SESSIONTYPES.PERSONAL' | translate }}
        </li>
        <li>
            <div class="subtitle-icon unavailabilities"></div>
            {{ 'SCHEDULE.SESSIONTYPES.UNAVAILABILITIES' | translate }}
        </li>
    </ul>
</div>